import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styles: [
    `
      :host {
        display: flex;
        background: theme('colors.sky.grey.light');
        height: 100%;
      }

      aside {
        display: flex;
        width: 288px;
        flex-direction: column;
        background: theme('colors.white');
        font-size: theme('fontSize.lg');
      }

      ng-scrollbar {
        height: auto;
      }
    `,
  ],
})
export class AppShellComponent implements OnInit {
  public initialFetch$ = this._userService.initialFetch$;
  public user$ = this._userService.user$;
  public provider$ = this._userService.selectedProvider$;
  public isMobileView$ = this._appService.isMobileView$.pipe(
    tap(isMobileView => {
      if (isMobileView) {
        this.mobileNav$.next({
          expand: false,
        });
      }
    })
  );

  public mobileNav$ = new BehaviorSubject({
    expand: false,
  });
  public showMobileNav$ = combineLatest([this.mobileNav$.pipe(map(state => state.expand)), this.isMobileView$]).pipe(
    distinctUntilChanged((current, last) => current[0] === last[0] && current[1].state === last[1].state),
    map(([isExpanded, isMobileView]) => isMobileView.state && isExpanded)
  );

  constructor(
    private readonly _appService: AppService,
    // private readonly _authService: AuthService,
    private readonly _userService: UserService,
    private readonly _router: Router
  ) {}

  public ngOnInit() {
    if (this._router.url === '/') {
      this._router.navigate(['dashboard']);
    }

    this._router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.mobileNav$.next({
          expand: false,
        });
      }
    });
  }

  public toggleNav(isNavOpened: boolean) {
    this.mobileNav$.next({
      expand: isNavOpened,
    });
  }
}
